import * as React from 'react';
import {Alert, Box, Button, FormControlLabel, Stack, Switch, Typography} from '@mui/material';
import {SettingsCard} from '../layouts/SettingsCard';
import {useEmailNotifications, useUpdateEmailNotifications} from '../../data/emailNotifications';
import {apiErrorMessage, isNetworkError} from '../../utilities/apiError';
import {describeEmailNotifications} from '../../utilities/emailNotifications';

// Whether the app emails this person a daily list of their overdue tasks. Off until they turn it on, and only sent once they have
// opened a link sent to their address (so nobody can be signed up for email by someone else typing their address).
export function EmailNotificationsCard() {
    const {data, isLoading, error: loadError} = useEmailNotifications();
    const {mutate, isPending, error, reset} = useUpdateEmailNotifications();
    const view = describeEmailNotifications(data);

    const failure = error ?? loadError;
    const failureText = !failure ? '' : isNetworkError(failure) ? 'Network error. Please try again later.' : apiErrorMessage(failure, "That didn't work. Try again.");

    return (
        <SettingsCard title="Email notifications" description="Get an email when tasks are overdue">
            {isLoading && <Typography variant="body2" color="text.secondary">Loading…</Typography>}

            {data && (
                <Stack spacing={1.5}>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={view.checked}
                                disabled={!view.enabled || isPending}
                                onChange={(_, checked) => { reset(); mutate(checked); }}
                                inputProps={{'aria-describedby': 'email-notifications-caption'}}
                            />
                        }
                        label="Email me a daily list of overdue tasks"
                    />
                    <Typography id="email-notifications-caption" variant="body2" color="text.secondary">{view.caption}</Typography>

                    {view.pending && (
                        <Box>
                            <Button size="small" variant="outlined" disabled={isPending} onClick={() => { reset(); mutate(true); }}>
                                Send the link again
                            </Button>
                        </Box>
                    )}
                </Stack>
            )}

            {failureText && <Alert severity="warning" sx={{mt: 2}}>{failureText}</Alert>}
        </SettingsCard>
    );
}
